module.exports = __webpack_public_path__ + "img/cogwheel.7de8d3ce.svg";